import { configureStore } from "@reduxjs/toolkit";
import userdashboard from "./components/dashboard/userDashboardReducer";
import loginUser from "./components/login/Login_reducer";
import productManagmentreducer from "./components/productManagement/productManagementReducer";
import trainingManagment from "../src/components/traningModule/traningmoduleReducer";
import BrandManagementReducer from "./components/BrandManagement/BrandManagementReducer";


// import trainingManagmentreducer from "./components/TraningModule/traningmoduleReducer"
import formSlice from "./form/formReducer";
import tableSlice from "./listing/listReducer";
import shopListSlice from "./components/dashboard/ShareLinks/Store_reducer"
import VatManagementReducer from "./components/vatManagement/VatManagementReducer";

// import globalSlice from './components/common/reducers/GlobalReducer'
import shopmanagementReducer from "./components/shopManagement/shopmanagementReducer";
import searchSlice from "./search/searchReducer";
import userManagementReducer from "./components/users/userManagementReducer";
import globalBackendReducer from "./components/globalBackendReducer"
import quizReducer from "./components/traningModule/Quiz/quizReducer";
import userInfoReducer from "./components/users/userInfoReducer";
import activeInactiveReducer from "./components/common/active N Inactive/activeInactiveReducer";
import tpmReducer from "./components/dashboard/ShareLinks/TPM/tpmReducer";
import  fileUploaderSlice from "./form/fileUploaderReducer"


export default configureStore({
    reducer: {
        loginUserKey: loginUser,
        shopListsKey: shopListSlice,
        userDashboardKey: userdashboard,
        userManagmentReducer: userManagementReducer,
        globalBackendReducer: globalBackendReducer,
        // allLesons: AllLessons,
        // allTraining: AllTraining,
        productManagmentReducer: productManagmentreducer,
        trainingManagmentReducer: trainingManagment,
        formSlice: formSlice,
        tableSlice: tableSlice,
        vatManagementReducer: VatManagementReducer,
        shopmanagementReducer: shopmanagementReducer,
        searchSlice: searchSlice,
        quizReducer: quizReducer,
        // globalSlice: globalSlice
        userInfoReducer: userInfoReducer,
        activeInactiveReducer:activeInactiveReducer,
        tpmReducer:tpmReducer,
        BrandManagementReducer:BrandManagementReducer,
        fileUploaderSlice


    },
});
// export function resetStore() {
//     store = configureStore(reducerConfiguration);
// }

// let reducerConfiguration = {
//     reducer: {
//         loginUserKey: loginUser,
//         shopListsKey: shopListSlice,
//         userDashboardKey: userdashboard,
//         userManagmentReducer: userManagementReducer,
//         globalBackendReducer: globalBackendReducer,
//         // allLesons: AllLessons,
//         // allTraining: AllTraining,
//         productManagmentReducer: productManagmentreducer,
//         trainingManagmentReducer: trainingManagment,
//         formSlice: formSlice,
//         tableSlice: tableSlice,
//         vatManagementReducer: VatManagementReducer,
//         shopmanagementReducer: shopmanagementReducer,
//         searchSlice: searchSlice,
//         // globalSlice: globalSlice

//     },
// }


// let store = configureStore(reducerConfiguration);

// export default store;

